import { render, staticRenderFns } from "./auto-block-dialog.vue?vue&type=template&id=4b9d1089&scoped=true&"
import script from "./auto-block-dialog.vue?vue&type=script&lang=js&"
export * from "./auto-block-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9d1089",
  null
  
)

export default component.exports